import { Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { useBookkeeperEnabled } from "./useBookkeeperEnabled";
import { useBookkeeperChat } from "./BookkeeperChatProvider";

/**
 * Header button that opens/closes the docked Bookkeeper Assistant. Renders
 * nothing unless the `bookkeeper_ai` flag is on (`useBookkeeperEnabled` — any
 * org role; the API filters Ré's tools per role) AND the chat provider is mounted
 * (so it's safe to place in a header used outside org-scoped routes too).
 */
export function BookkeeperHeaderToggle() {
  const { t } = useTranslation("common");
  const enabled = useBookkeeperEnabled();
  const chat = useBookkeeperChat();
  if (!enabled || !chat.isAvailable) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn("h-9 w-9", chat.isOpen && "bg-accent text-accent-foreground")}
      onClick={chat.toggle}
      title={t("bookkeeper.title")}
      aria-pressed={chat.isOpen}
    >
      <Sparkles className="h-4 w-4" />
    </Button>
  );
}
